/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Toast } from 'vant';
import ListDate from '@/components/ListDate/indexCopy';
import DateMealPiliangbaoting from './DateMealPiliangbaoting';
import DateMealDanBaoting from './DateMealDanBaoting';
import * as util from '@/utils/common.js';
import { encrypt } from "../../utils/jsencrypt";
export default {
  components: {
    ListDate: ListDate,
    DateMealPiliangbaoting: DateMealPiliangbaoting,
    DateMealDanBaoting: DateMealDanBaoting
  },
  data: function data() {
    return {
      aaa: false,
      result: [],
      subOrderId: '',
      dtype: [{
        value: '周',
        index: 0
      } //  { value: '月', index: 1 },
      ],
      //选日期的数组
      nowType: 0,
      //当前选的日期
      dateStart: '',
      //开始时间
      dateEnd: '',
      //结束时间
      showConfirm: false,
      //日历的显示
      fadeShow: false,
      //切换时间的动画
      weekList: [],
      //周数组
      timestamp: 0,
      //当前时间戳
      currDate: '',
      //日历选择的时间
      detailsShow: false,
      //订单详情
      FoodInfoShow: false,
      //订餐信息
      revampShow: false,
      //订餐修改
      revampVal: 0,
      //修改的份数
      verifyShow: false,
      //订餐确认
      foodList: [],
      //餐别
      list: [],
      //每日餐
      rightNext: 0,
      leftNext: 0,
      orderDetail: {
        time: '',
        //预定时间
        mealType: '',
        // 早 中 晚
        orderNumber: '',
        // 份数
        money: '100',
        //消费金额
        status: '已定餐',
        payStatus: '支付成功'
      },
      orderBalance: 0,
      //订单差额
      isOrderMeal: false,
      //单餐订餐
      isPayment: false,
      //预定餐结果
      isSuccess: true,
      //支付成功
      isOrder: false,
      //判断是否点击了批量订餐
      orderNum: 1,
      orderList: [],
      //批量订餐的数组
      isOrderManyMeal: false,
      dangtianTime: '',
      //用于判读当天就餐时间是否过期
      depSerial: '',
      //餐厅ID
      verifyShowDan: false,
      isBaotingHuifu: '',
      currDateTime: '',
      pandanshijian: ''
    };
  },
  methods: {
    stopMeal: function stopMeal(info, isOverTime) {
      if (isOverTime) {
        if (info.mealState == 2 && info.isLateTime == 0 && info.isLate == 0) {
          this.dangebao(info.subOrderId, 4);
        } else if ((info.mealState == 1 || info.mealState == 4 || info.mealState == 5) && info.isLate == 0 && info.isLateTime == 0) {
          this.dangebao(info.subOrderId, 2);
        }
      }
    },
    isNotOverTime: function isNotOverTime(date) {
      var nowTime = new Date();
      var hour = nowTime.getHours(); //得到小时

      var minutes = nowTime.getMinutes(); //得到分钟

      var dateTime = date.split(":");

      if (hour > dateTime[0]) {
        //当前小时大于结束日期
        return false;
      } else if (hour == dateTime[0]) {
        if (minutes > dateTime[1]) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    isToday: function isToday(date) {
      var todayDate = new Date().setHours(0, 0, 0, 0); //把今天的日期时分秒设置为00：00：00，返回一个时间戳,

      var paramsDate = new Date(date).setHours(0, 0, 0, 0); //给new Date()传入时间，并返回传入时间的时间戳

      return todayDate === paramsDate;
    },
    dangebao: function dangebao(subOrderId, isBaotingHuifu) {
      if (this.isOrder) {
        var index = this.result.findIndex(function (id) {
          return id === subOrderId;
        });

        if (index > -1) {
          this.result.splice(index, 1);
        } else {
          this.result.push(subOrderId);
        }
      } else {
        this.subOrderId = subOrderId;
        this.isBaotingHuifu = isBaotingHuifu;
        this.verifyShowDan = true;
      }
    },
    closeConfirmdan: function closeConfirmdan() {
      this.verifyShowDan = false;
    },
    //确定订餐

    /**
     * 1:确定订餐时先将过期的排除
     * 2:筛选 mealstauts为1
     */
    comfirmOrderMeal: function comfirmOrderMeal() {
      if (this.result.length == 0) {
        Toast("未选取要报停的餐别");
        return;
      }

      this.verifyShow = true;
    },
    //订餐的数组中删除已过器
    handleOverdueMeal: function handleOverdueMeal(arr) {
      var _this = this;

      var newList = util.deepcopy(this.list);

      for (var i = 0; i < arr.length; i++) {
        newList.splice(0, 1);
      }

      this.orderList = []; //订餐列表
      //找出批量订餐中mealstauts==1且订餐数量大于1

      /**
       * 构建数组[
       *  {time:'',mealArr:[]}
       * ]
       * 用于弹窗展示
       */

      newList.forEach(function (item, index) {
        _this.findMeal(item).then(function (res) {
          var obj = {
            time: listArr[index].day,
            mealArr: res
          };

          _this.orderList.push(obj);
        });
      });
      var listArr = this.weekList.filter(function (item) {
        return item.old != true;
      });
      this.isOrderManyMeal = true;
    },
    findMeal: function findMeal(arr) {
      return new Promise(function (resolve) {
        var list = [];
        arr.forEach(function (item) {
          if (item.mealstauts == 1 && item.orderNum > 0) {
            list.push(item);
          }
        });
        if (list.length > 0) resolve(list);
      });
    },
    //批量订餐成功
    paymentMeal: function paymentMeal() {
      this.isOrderManyMeal = false;
      this.isPayment = true;
    },
    //批量订餐减少
    reduce: function reduce(item) {
      if (item.orderNum < 1) return;
      item.orderNum = item.orderNum - 1;
    },
    //批量订餐增加
    add: function add(item) {
      item.orderNum = item.orderNum + 1;
    },
    //点击批量订餐
    orderFood: function orderFood() {
      this.aaa = true;
      this.isOrder = true;
    },
    quxiaopiliang: function quxiaopiliang() {
      this.aaa = false;
      this.isOrder = false;
      this.result = [];
    },
    //关闭支付弹窗
    closePay: function closePay() {
      this.isPayment = false;
    },
    //订餐页面关闭
    comfirmOrder: function comfirmOrder() {
      this.isOrderMeal = false;
      this.isPayment = true;
    },
    //订单提示弹窗关闭
    closeConfirm: function closeConfirm() {
      this.verifyShow = false;
    },
    //修改金额弹窗关闭
    closeMoney: function closeMoney() {
      if (this.FoodInfoShow) this.FoodInfoShow = false;
      if (this.isOrderMeal) this.isOrderMeal = false;
    },
    //确定修改金额
    comfirmModify: function comfirmModify(money) {
      this.FoodInfoShow = false;
      this.verifyShow = true;
      this.orderBalance = money;
    },
    // 关闭订单
    closePopUp: function closePopUp() {
      if (this.detailsShow) this.detailsShow = false;
      if (this.isOrderManyMeal) this.isOrderManyMeal = false;
    },
    //修改订单
    orderModif: function orderModif() {
      this.detailsShow = false;
      this.FoodInfoShow = true;
    },
    //显示订单详情
    showModifyMsg: function showModifyMsg(item, k, index) {
      if (this.isOrder) return; //k用判断是餐别  index 用于取时间

      this.orderDetail.mealType = this.foodList[k].mealType;
      this.orderDetail.time = this.weekList[index].day + '   周 ' + this.weekList[index].week;
      this.orderDetail.orderNumber = item.num;

      if (item.mealstauts == 2) {
        this.detailsShow = true;
      } else if (item.mealstauts == 1) {
        this.isOrderMeal = true;
      }
    },
    toMove: function toMove() {
      var num = Math.ceil(this.foodList.length / 3);
      if (this.rightNext + 1 == num || this.rightNext + 1 > num) return;
      this.rightNext++;
      this.leftNext = this.rightNext;
      var leftDis = -this.rightNext * 0.99 + 'rem';
      this.$refs.foodRegion.style.left = leftDis;
    },
    toMoveLeft: function toMoveLeft() {
      if (this.leftNext == 0) return;
      this.leftNext--;
      this.rightNext = this.leftNext;
      var leftDis = this.leftNext * 0.99 + 'rem';
      this.$refs.foodRegion.style.left = leftDis;
    },
    typeClick: function typeClick(index) {
      this.nowType = index;
      this.dateStart = new Date();
      this.setDateList(0);
    },
    // 切换头部时间的区间
    cutDate: function cutDate(num) {
      this.setDateList(1, num);
    },
    //  时间切换后的列表
    // type 0  默认是周/月  1 是来回切换上周/上月
    // cutDate 0 上  1 下
    setDateList: function setDateList() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var cutDate = arguments.length > 1 ? arguments[1] : undefined;
      var start, end, dayNum;

      if (this.nowType == 0) {
        if (type == 0) {
          start = this.$utils.DateUtils.getBeginWeek(this.dateStart);
        } else {
          start = cutDate == 0 ? this.$utils.DateUtils.getBeginLastWeek(this.dateStart) : this.$utils.DateUtils.lastMonday(this.dateEnd, 0);
        }

        this.getWeekList(start, 7); // dayNum=
      } else {
        if (type == 0) {
          start = this.$utils.DateUtils.getBeginMonth(this.dateStart);
        } else {
          start = cutDate == 0 ? this.$utils.DateUtils.getBeginLastMonth(this.dateStart) : this.$utils.DateUtils.getNextMonth(this.dateStart);
        }

        end = this.$utils.DateUtils.getEndMonth(start);
        dayNum = this.$utils.DateUtils.DateDiff(this.formatDate(start), this.formatDate(end));
        this.getWeekList(start, dayNum + 1);
      }
    },
    formatDateTime: function formatDateTime(date) {
      date = new Date(date);
      return "".concat(date.getHours(), ":").concat(date.getMinutes());
    },
    zhuanhuariqi: function zhuanhuariqi(date) {
      date = new Date(date.replace(/-/g, '/'));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '/' + m + '/' + d;
    },
    formatDate: function formatDate(date) {
      date = new Date(date);
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    },
    onConfirm: function onConfirm(beginDate, endDate) {
      var dayNum = this.$utils.DateUtils.DateDiff(beginDate, endDate);

      if (dayNum > 7) {
        this.nowType = 1;
      } else {
        this.nowType = 0;
      }

      this.getWeekList(beginDate, dayNum + 1);
    },

    /**
     * 处理餐厅订餐情况
     *
     */
    handleMeal: function handleMeal(index) {
      var mealList = this.list[index];
      mealList.forEach(function (item) {
        item.mealstauts = '0';
      });
    },
    getFritWeekList: function getFritWeekList(value) {
      var _this2 = this;

      var numday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;

      if (typeof value == 'string') {
        value = new Date(value.replace(/-/g, '/'));
      }

      this.weekList = [];
      value = this.$utils.DateUtils.getTimeStamp(value) * 1000;

      for (var i = 0; i < numday; i++) {
        var curWeek = value + i * 24 * 3600 * 1000; //获取当前周几的时间戳

        this.weekList.push({
          day: this.$utils.DateUtils.formatTimeStamp(curWeek),
          week: this.$utils.DateUtils.getWeekCnOne(curWeek) // old:this.$utils.DateUtils.oldDate( this.weekList[i].day)

        }); //根据周几的时间戳返回周几的日期

        this.dateStart = this.weekList[0].day;
        this.dateEnd = this.weekList[this.weekList.length - 1].day;
        this.weekList.forEach(function (element) {
          element.old = _this2.$utils.DateUtils.oldDate(element.day);
        });
      }
    },

    /**
     * @function获取当前周或者月数组
     *      wzx
     *   2019.05.05
     **/
    getWeekList: function getWeekList(value) {
      var _this3 = this;

      var numday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;

      if (typeof value == 'string') {
        value = new Date(value.replace(/-/g, '/'));
      }

      this.weekList = [];
      value = this.$utils.DateUtils.getTimeStamp(value) * 1000;

      for (var i = 0; i < numday; i++) {
        var curWeek = value + i * 24 * 3600 * 1000; //获取当前周几的时间戳

        this.weekList.push({
          day: this.$utils.DateUtils.formatTimeStamp(curWeek),
          week: this.$utils.DateUtils.getWeekCnOne(curWeek) // old:this.$utils.DateUtils.oldDate( this.weekList[i].day)

        }); //根据周几的时间戳返回周几的日期

        this.dateStart = this.weekList[0].day;
        this.dateEnd = this.weekList[this.weekList.length - 1].day;
        this.weekList.forEach(function (element) {
          element.old = _this3.$utils.DateUtils.oldDate(element.day);
        });
      }

      this.currDate = this.zhuanhuariqi(this.weekList[0].day);
      this.getRqMeals(this.weekList[0].day);
    },

    /**
     * @function获取当前日期
     *      wzx
     *   2019.04.12
     **/
    zhuanhuariqia: function zhuanhuariqia(date) {
      date = new Date(date.replace(/-/g, '/'));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },
    getSysDate: function getSysDate() {
      var _this4 = this;

      this.$utils.Tools.loadShow('加载数据');
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this4.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this4.$code.success) {
          Toast(msg);
        } else {
          _this4.currDate = _this4.zhuanhuariqi(data.sysDate);
          _this4.currDateTime = _this4.formatDateTime(data.sysDate);
          _this4.pandanshijian = _this4.currDate;
          _this4.dangtianTime = _this4.zhuanhuariqi(data.sysDate);
          _this4.timestamp = _this4.$utils.DateUtils.getBeginWeek(data.sysDate);

          _this4.getFritWeekList(_this4.timestamp, 7);

          _this4.getRqMeals(_this4.zhuanhuariqia(data.sysDate));
        }
      }).catch(function () {
        _this4.$utils.Tools.httpError();
      });
    },
    getRqMeals: function getRqMeals(aa) {
      var _this5 = this;

      this.$utils.Tools.loadShow('加载数据');
      this.$api.BaoTing.getRqMeals({
        userSerial: this.$utils.Store.getItem('userSerial'),
        date: aa,
        placeId: this.$route.query.placeId
      }).then(function (response) {
        _this5.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this5.$code.success) {
          _this5.$utils.Tools.toastShow(msg);
        } else {
          _this5.foodList = data.meal;
          _this5.list = data.list;
        }
      }).catch(function () {
        _this5.$utils.Tools.httpError();
      });
    },
    dangebaoting: function dangebaoting(subOrderId, isBaotingHuifu) {
      var _this6 = this;

      this.$utils.Tools.loadShow('加载数据');
      this.subOrderId = subOrderId;
      this.$api.BaoTing.baoting({
        subOrderIdList: [encrypt(subOrderId.toString())],
        mealState: isBaotingHuifu
      }).then(function (response) {
        _this6.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this6.$code.success) {
          _this6.$utils.Tools.toastShow(msg);

          _this6.subOrderId = '';
          _this6.verifyShow = false;
          _this6.verifyShowDan = false;
          _this6.result = [];
        } else {
          _this6.verifyShow = false;
          _this6.subOrderId = '';

          _this6.$utils.Tools.toastShow(msg);

          _this6.verifyShowDan = false;
          _this6.result = [];

          _this6.getRqMeals(_this6.zhuanhuariqia(_this6.currDate));
        }
      }).catch(function () {
        _this6.$utils.Tools.httpError();
      });
    },
    baoting: function baoting() {
      var _this7 = this;

      this.$utils.Tools.loadShow('提交数据');
      var subOrderIdList = this.result.map(function (item) {
        return encrypt(item);
      });
      this.$api.BaoTing.baoting({
        subOrderIdList: subOrderIdList,
        mealState: 2
      }).then(function (response) {
        _this7.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this7.$code.success) {
          _this7.$utils.Tools.toastShow(msg);

          _this7.verifyShow = false;
          _this7.result = [];
        } else {
          _this7.verifyShow = false;

          _this7.$utils.Tools.toastShow(msg);

          _this7.result = [];

          _this7.getRqMeals(_this7.zhuanhuariqia(_this7.currDate));
        }
      }).catch(function () {
        _this7.$utils.Tools.httpError();
      });
    }
  },
  created: function created() {
    this.getSysDate();
  }
};